export default __webpack_public_path__ + "static/media/brownie.f293c316.jpg";